import { render, staticRenderFns } from "./PermissionErrorPage.vue?vue&type=template&id=43b919a1&"
import script from "./PermissionErrorPage.vue?vue&type=script&lang=js&"
export * from "./PermissionErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports